(function() {
  'use strict';

  // Check if config exists
  if (!window.footerIterableConfig) {
    console.warn('Footer Iterable config not found');
    return;
  }

  const config = window.footerIterableConfig;
  const form = document.getElementById('ContactFooter');
  const emailInput = document.getElementById('NewsletterForm');

  if (!form || !emailInput) {
    return;
  }

  // Helper function to capitalize first letter
  function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  // Form submit handler
  form.addEventListener('submit', async function(e) {
    const email = emailInput.value.trim();

    if (!email || !config.apiUrl || !config.apiKey) {
      // Let form submit naturally
      return;
    }

    // Build siteID and source
    const siteID = `${config.brand}_${config.region}`.toUpperCase();
    const source = `${capitalizeFirstLetter(config.brand)}_footer`;

    // Build payload
    const payload = {
      requestType: 'sendDataToIterable',
      siteID: siteID,
      data: {
        email: email,
        country: config.countryName,
        countryCode: config.countryCode,
        source: source
      }
    };

    // Fire-and-forget API call
    try {
      fetch(`${config.apiUrl}/admin-actions`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': config.apiKey
        },
        body: JSON.stringify(payload)
      }).catch(err => {
        // Silent fail - don't block form submission
        console.warn('Iterable API call failed:', err);
      });
    } catch (err) {
      // Silent fail - don't block form submission
      console.warn('Iterable API call error:', err);
    }

    // Form submission continues naturally (no preventDefault)
  });
})();
